import { render } from "./ballLossSet.vue?vue&type=template&id=f1f91d1e&scoped=true"
import script from "./ballLossSet.vue?vue&type=script&lang=js"
export * from "./ballLossSet.vue?vue&type=script&lang=js"

import "./ballLossSet.vue?vue&type=style&index=0&id=f1f91d1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f91d1e"]])

export default __exports__